import { render, staticRenderFns } from "./activity-video_activity.vue?vue&type=template&id=1cf555bd&"
import script from "./activity-video_activity.vue?vue&type=script&lang=js&"
export * from "./activity-video_activity.vue?vue&type=script&lang=js&"
import style0 from "./activity-video_activity.vue?vue&type=style&index=0&id=1cf555bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports